"use strict";

var projectDetail = function projectDetail() {
  var slider = new Swiper('[data-project-detail-slider]', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".project-detail__slider__next",
      prevEl: ".project-detail__slider__prev"
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar'
    },
    breakpoints: {
      1024: {
        slidesPerView: 2
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', projectDetail);